<template>
  <div class="home-child-wrapper community-container">
    <el-container>
      <el-aside width="150px">
        <div class="left-aside">
          <ul class="feed-menu">
            <li :class="hotActive" @click="switchHotFeed">热门</li>
            <li :class="recommendActive" @click="switchRecommendFeed">推荐</li>
          </ul>
        </div>
      </el-aside>
      <el-main class="main-wrapper">
        <div class="search-container">
          <div class="search-wrapper">
            <el-autocomplete
              class="search-input"
              v-model="searchKey"
              :fetch-suggestions="querySearchAsync"
              :debounce="0"
              placeholder="请输入标题、网名等关键字段"
              @select="handleSelect"
              @keyup.enter.native="onSearch"
              clearable
              ref="searchInput"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="onSearch"
              ></el-button>
              <template slot-scope="{ item }">
                <div class="history-item" @click="selectHistoryItem(item)">
                  <span class="item-text ellipsis">{{ item.keyword }}</span>
                  <el-dropdown
                    size="mini"
                    placement="right"
                    @command="handleDelete"
                  >
                    <span class="delete-btn">
                      <i class="el-icon-close"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="item.id"
                        >删除记录</el-dropdown-item
                      >
                      <el-dropdown-item command="all"
                        >清空所有记录</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-autocomplete>
          </div>
        </div>
        <div class="feed-container" v-if="hotFeed" v-loading="hotShade">
          <FeedItem
            v-for="feed in hotList"
            :key="feed.modelId"
            :feed="feed"
            :headScene="headScene"
          />
        </div>
        <div class="feed-container" v-else v-loading="recommendShade">
          <FeedItem
            v-for="feed in recommendList"
            :key="feed.modelId"
            :feed="feed"
            :headScene="headScene"
          />
        </div>
        <ShareHandLian />
        <PhotoPreviewer />
        <AvatarPreviewer />
      </el-main>
      <el-aside width="340px">
        <div class="right-aside">
          <div class="profile-wrapper">
            <UserProfile :profile="userProfile" :profileMenu="profileMenu" />
          </div>
        </div>
      </el-aside>
    </el-container>
    <div class="message-aside">
      <MessageMenu />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { apiMap } from "../utils/apiMap";
import UserProfile from "../components/UserProfile";
// import { tranNumber } from "../js/chat";
// import { sortHotFeed } from "../utils/feed";
import { reviewTime } from "../utils/date";
import PhotoPreviewer from "../components/PhotoPreviewer";
import AvatarPreviewer from "../components/AvatarPreviewer";
import FeedItem from "../components/community/feed-item";
import MessageMenu from "../components/message-aside/message-menu";
import ShareHandLian from "../components/ShareHandLian";
export default {
  name: "community",
  data() {
    return {
      hotFeed: true,
      hotShade: true,
      recommendShade: true,
      value: "",
      restaurants: [],
      searchKey: "",
      timeout: null,
      count: 0,
      hotPage: 1,
      recommendPage: 1,
      fetchHot: true,
      fetchRecomment: true,
      onFetching: false,
      hotList: [],
      recommendList: [],
      topList: [],
      authorList: [],
      profileMenu: {
        linkBtn: true,
        addFriendBtn: false,
        copyTreeBtn: false,
        modifyTreeBrn: false,
        apllyTreeBtn: false,
      },
      headScene: "community",
    };
  },
  components: {
    UserProfile,
    PhotoPreviewer,
    AvatarPreviewer,
    FeedItem,
    MessageMenu,
    ShareHandLian,
  },
  computed: {
    ...mapGetters([
      "userProfile",
      "conversationList",
      "currentConversation",
      "contactsList",
      "croupsList",
      "commentList",
    ]),
    hotActive: function() {
      if (this.hotFeed == true) {
        return "active";
      } else {
        return "inactive";
      }
    },
    recommendActive: function() {
      if (this.hotFeed == false) {
        return "active";
      } else {
        return "inactive";
      }
    },
  },
  mounted() {
    // this.restaurants = this.loadAll();
    this.getSearchRecords((res) => {
      this.restaurants = res;
    });
    window.addEventListener("scroll", this.handleScroll);
    this.$bus.$on("update-follow-status", this.updateFollowStatus);
    this.$bus.$on("unshare-community-feed", this.unShareFeedOnCommunity);
  },
  beforeMount() {
    this.getHotFeed();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    switchHotFeed() {
      window.scroll(0, 0);
      this.hotFeed = true;
      this.hotShade = true;
      this.onFetching = false;
      this.hotPage = 1;
      this.hotList = [];
      this.topList = [];
      this.recommendList = [];
      this.getHotFeed();
    },
    switchRecommendFeed() {
      window.scroll(0, 0);
      this.hotFeed = false;
      this.onFetching = false;
      this.recommendShade = true;
      this.recommendPage = 1;
      this.hotList = [];
      this.topList = [];
      this.recommendList = [];
      this.getRecommendFeed();
    },
    querySearchAsync(queryString, cb) {
      // let test = this.$refs.searchInput.suggestionVisible;
      // console.log(test);
      // var restaurants = this.restaurants;
      // var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      //     cb(results);
      // }, 1000 * Math.random());
      cb(this.restaurants);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      this.searchKey = item.keyword;
    },
    handleDelete(itemID) {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = `token=${loginUser.token}`;
      if (itemID !== "all") {
        params = `token=${loginUser.token}&id=${itemID}`;
        $this.restaurants = $this.restaurants.filter(
          (item) => item.id !== itemID
        );
        $this.$refs.searchInput.focus();
      } else {
        $this.restaurants = [];
      }

      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["removeSearchRecord"]["method"],
          url: apiMap["removeSearchRecord"]["url"],
          data: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            $this.getSearchRecords((res) => {
              $this.restaurants = res;
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onSearch() {
      // let test = this.$refs.searchInput.activated;
      // console.log(this.$refs.searchInput);
      if (this.searchKey === "" || this.searchKey.trim().length === 0) {
        this.searchKey = "";
        this.$store.dispatch("showMessage", {
          message: "搜索内容不能为哦！",
          type: "warning",
        });
        return;
      }
      if (this.$refs.searchInput.activated == true) {
        this.$refs.searchInput.activated = false;
      }

      if (this.hotFeed == true) {
        this.hotPage = 1;
        this.getHotFeed();
      } else {
        this.recommendPage = 1;
        this.getRecommendFeed();
      }
    },
    getSearchRecords(cb) {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getSearchRecords"]["method"],
          url: apiMap["getSearchRecords"]["url"],
          params: {
            token: loginUser.token,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            cb(response.data.result.data.reverse());
          } else {
            $this.restaurants = [];
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getHotFeed() {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = `token=${loginUser.token}&start=${this.hotPage}&count=10&word=${this.searchKey}`;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["hotFeed"]["method"],
          url: apiMap["hotFeed"]["url"],
          data: params,
          timeout: 4000,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            // response.data.result.data.forEach(element => {
            //     $this.hotList.push(element);
            // });
            $this.hotShade = false;
            let sortedData = response.data.result.data;
            // let sortedData = sortHotFeed(response.data.result.data);
            if (sortedData.length == 0) {
              $this.$message({
                message: "暂无数据",
              });
              $this.fetchHot = false;
              return false;
            }
            if ($this.searchKey !== "" || $this.searchKey.trim().length !== 0) {
              if ($this.hotPage == 1) {
                $this.hotList = [];
              }
            }
            for (let index = 0; index < sortedData.length; index++) {
              const element = sortedData[index];
              //过滤音频 和 视频 和未通过审核的动态
              if (element.article == 3 || element.article == 4) {
                continue;
              }
              var topStatus = "noRecord";
              if (element.top == 1) {
                if ($this.topList.includes(element.modelId)) {
                  topStatus = "hasRecord";
                } else {
                  $this.topList.push(element.modelId);
                }
                var unTopArr = sortedData.filter((item) => item.top == 0);
                if (unTopArr.length == 0) {
                  $this.finishTip(1);
                }
              }
              var diffTime =
                response.data.result.requestTime - element.created_at;
              var reviewStatus = diffTime > reviewTime ? "pass" : "fail";
              if (reviewStatus == "pass" && topStatus == "noRecord") {
                $this.hotList.push(element);
              }
              // if (element.userType == 1) {
              //   var authorInfo = {
              //     userID: element.userId,
              //     userName: element.userInfo.name,
              //     followStatus: element.subscribe,
              //   };
              //   if ($this.authorList.length !== 0) {
              //     let findAuthor = $this.authorList.filter(
              //       (item) => item.userID == element.userId
              //     );
              //     if (findAuthor.length == 0) {
              //       $this.authorList.push(authorInfo);
              //     }
              //   } else {
              //     $this.authorList.push(authorInfo);
              //   }
              // }
            }
            if (sortedData.length !== 0 && $this.searchKey == "") {
              $this.getAdvertiseList();
            }
          }
          if (response.data.result.data.length == 0) {
            $this.$message({
              message: "热点数据加载完啦，请浏览其他内容",
            });
            $this.fetchHot = false;
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.message.includes("timeout")) {
            $this.$message({
              message: "获取社区动态超时",
            });
          } else {
            $this.$message({
              message: "获取社区动态出错",
              type: "warning",
            });
          }
        });
    },
    unShareFeedOnCommunity(feedID, feedType) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let requestUrl = "";
      let method = "";
      let params = "";
      switch (feedType) {
        case 1:
          requestUrl = apiMap["articleShare"]["url"];
          method = apiMap["articleShare"]["method"];
          params = `token=${loginUser.token}&articleId=${feedID}&shareField=sharePublic&shareValue=0`;
          break;
        case 2:
          requestUrl = apiMap["albumShare"]["url"];
          method = apiMap["albumShare"]["method"];
          params = `token=${loginUser.token}&photoId=${feedID}&shareField=sharePublic&shareValue=0`;
          break;
        case 3:
          requestUrl = apiMap["musicShare"]["url"];
          method = apiMap["musicShare"]["method"];
          params = `token=${loginUser.token}&musicId=${feedID}&shareField=sharePublic&shareValue=0`;
          break;
        case 4:
          requestUrl = apiMap["videoShare"]["url"];
          method = apiMap["videoShare"]["method"];
          params = `token=${loginUser.token}&videoId=${feedID}&shareField=sharePublic&shareValue=0`;
          break;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: method,
          url: requestUrl,
          data: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (_this.hotFeed == true) {
              //hotList: [], recommendList: [],
              var findIndex = -1;
              _this.hotList.filter((item, index) => {
                if (item.modelId == feedID && item.article == feedType) {
                  findIndex = index;
                }
              });
              if (findIndex != -1) {
                _this.hotList.splice(findIndex, 1);
                _this.$message({
                  message: "操作成功！",
                  type: "success",
                });
              }
            } else {
              var findIndex = -1;
              _this.recommendList.filter((item, index) => {
                if (item.modelId == feedID && item.article == feedType) {
                  findIndex = index;
                }
              });
              if (findIndex != -1) {
                _this.recommendList.splice(findIndex, 1);
                _this.$message({
                  message: "操作成功！",
                  type: "success",
                });
              }
            }
          } else {
            _this.$message({
              message: "操作失败，稍后再试",
              type: "warning",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getRecommendFeed() {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = `token=${loginUser.token}&start=${this.recommendPage}&count=10&word=${this.searchKey}`;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["recommendFeed"]["method"],
          url: apiMap["recommendFeed"]["url"],
          data: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (response.data.result.data.length == 0) {
              $this.$message({
                message: "暂无数据",
              });
              $this.fetchRecomment = false;
              return false;
            }
            if ($this.searchKey !== "" || $this.searchKey.trim().length !== 0) {
              if ($this.recommendPage == 1) {
                $this.recommendList = [];
              }
            }
            let recommendData = response.data.result.data;
            for (let index = 0; index < recommendData.length; index++) {
              const element = recommendData[index];
              //过滤音频 和 视频 和未通过审核的动态
              if (element.article == 3 || element.article == 4) {
                continue;
              }
              var topStatus = "noRecord";
              if (element.top == 1) {
                if ($this.topList.includes(element.modelId)) {
                  topStatus = "hasRecord";
                } else {
                  $this.topList.push(element.modelId);
                }
                var unTopArr = recommendData.filter((item) => item.top == 0);
                if (unTopArr.length == 0) {
                  $this.finishTip(2);
                }
              }
              var diffTime =
                response.data.result.requestTime - element.created_at;
              var reviewStatus = diffTime > reviewTime ? "pass" : "fail";
              if (reviewStatus == "pass" && topStatus == "noRecord") {
                $this.recommendList.push(element);
              }
            }
            $this.recommendShade = false;
          }
          if (response.data.result.data.length == 0) {
            $this.$message({
              message: "推荐数据加载完啦，请浏览其他内容",
            });
            $this.fetchRecomment = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    finishTip(type) {
      var handle = type == 1 ? "热门" : "推荐";
      this.$message({
        message: `${handle}动态加载完啦，请浏览其他内容`,
      });
      this.onFetching = true;
    },
    selectHistoryItem(data) {
      if (data && data.keyword) {
        this.searchKey = data.keyword;
        this.onSearch();
      }
    },
    updateFollowStatus(data) {
      if (this.hotFeed == true) {
        console.log(this.hotList);
        for (let index = 0; index < this.hotList.length; index++) {
          var element = this.hotList[index];
          if (element.userId == data.userID) {
            element.subscribe = data.status;
            console.log(element);
            this.$set(this.hotList, [element], element);
          }
        }
      } else {
        console.log(this.recommendList);
        for (let index = 0; index < this.recommendList.length; index++) {
          var element = this.recommendList[index];
          if (element.userId == data.userID) {
            element.subscribe = data.status;
            this.$set(this.recommendList, [element], element);
          }
        }
      }
    },
    getAdvertiseList() {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = `token=${loginUser.token}&start=${this.hotPage}&count=1`;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["advertiseList"]["method"],
          url: apiMap["advertiseList"]["url"],
          data: params,
          timeout: 4000,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (response.data.result.data.length != 0) {
              $this.hotList.splice(
                $this.hotList.length - 2,
                0,
                response.data.result.data[0]
              );
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    handleScroll() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      if (this.onFetching) {
      } else {
        if (windowHeight >= scrollHeight - scrollTop - 140) {
          this.onFetching = true;
          setTimeout(() => {
            if (this.hotFeed == true && this.fetchHot == true) {
              this.hotPage += 1;
              this.getHotFeed();
            } else if (this.hotFeed == false && this.fetchRecomment == true) {
              this.recommendPage += 1;
              this.getRecommendFeed();
            }
            this.onFetching = false;
          }, 500);
        }
      }
    },
  },
};
</script>

<style scoped>
.main-wrapper {
  margin-left: 10px;
}

.feed-container {
  width: 670px;
  min-height: 216px;
  /* margin: 88px auto 0; */
  margin-top: 88px;
  margin-left: 10px;
}

.left-aside {
  position: fixed;
  width: 150px;
  text-align: center;
  line-height: 40px;
  /* background-color: #ccc; */
}

.left-aside .feed-menu {
  margin-top: 20px;
  background-color: #fff;
}

.feed-menu li {
  font-size: 16px;
  cursor: pointer;
}

.feed-menu .active {
  color: #409eff;
}

.search-container {
  position: fixed;
  width: 690px;
  height: 82px;
  text-align: center;
  z-index: 5;
  background-color: #f6f7f8;
}

.search-container .search-wrapper {
  margin: 20px 10px 0;
  padding: 10px;
  background-color: #fff;
}

.search-container .clear-wrapper {
  position: relative;
  top: -10px;
  margin: 0 10px;
  padding: 0 158px 0 100px;
  height: 30px;
  line-height: 30px;
  color: #808080;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
}

.clear-wrapper .clear-btn {
  position: relative;
  cursor: pointer;
}

.clear-btn .el-icon-delete {
  margin-right: 2px;
}

.clear-wrapper .clear-btn:hover {
  color: #ff6600;
}

.search-wrapper .el-autocomplete {
  width: 638px;
}

.search-container .history-container {
  background-color: #e5eeff;
}

.history-item {
  display: flex;
  justify-content: space-between;
}

.history-item .item-text {
  max-width: 360px;
}

.history-item .delete-btn {
  width: 20px;
  text-align: right;
}

.history-item .delete-btn:hover {
  color: #ff6600;
}

.infinite-list {
  padding: 0;
  margin: 0;
  list-style: none;
}

.right-aside {
  position: fixed;
  width: 340px;
}

.right-aside .profile-wrapper {
  margin-top: 20px;
  background-color: #fff;
}
</style>
